import { FC } from 'react';

import { Grid, Typography } from '@mui/material';

import { maskString } from 'src/utils/validations';

type Bank = {
    id?: number;
    bic: string;
    iban: string;
    sortCode: string;
    accountNumber: string;
};

interface PaymentDetailProps {
    label: string;
    value: string;
    viewPaymentDetails?: boolean;
}

interface PaymentDetailsProps {
    viewPaymentDetails?: boolean;
    bank?: Bank;
}

const PaymentDetail: FC<PaymentDetailProps> = ({ label, value, viewPaymentDetails }) => {
    return (
        <Grid item container xs={12}>
            <Grid md={3}>
                <Typography sx={{ fontSize: '16px', fontWeight: '700', color: '#575757' }}>
                    {label}
                </Typography>
            </Grid>
            <Grid md={9}>
                <Typography>{viewPaymentDetails ? value : maskString(value)}</Typography>
            </Grid>
        </Grid>
    );
};

const PaymentDetails: FC<PaymentDetailsProps> = ({ bank, viewPaymentDetails }) => {
    return (
        <Grid
            sx={{
                padding: '0 24px 24px 24px',
                display: 'flex',
                flexDirection: 'column',
            }}
            gap={1}
        >
            {bank?.bic && (
                <PaymentDetail
                    viewPaymentDetails={viewPaymentDetails}
                    label="BIC"
                    value={bank.bic || '-'}
                />
            )}
            <PaymentDetail
                viewPaymentDetails={viewPaymentDetails}
                label="IBAN"
                value={bank?.iban || '-'}
            />

            {bank?.sortCode && bank?.accountNumber && (
                <>
                    <PaymentDetail
                        viewPaymentDetails={viewPaymentDetails}
                        label="Sort Code"
                        value={bank?.sortCode || '-'}
                    />
                    <PaymentDetail
                        viewPaymentDetails={viewPaymentDetails}
                        label="Account Number"
                        value={bank?.accountNumber || '-'}
                    />
                </>
            )}
        </Grid>
    );
};

export default PaymentDetails;
